import * as swcHelpers from '@swc/helpers';
import { getLocalizedAttrValue } from '@grandvisionhq/utils';
import { getAttribute } from '../../../../../utils/get-line-item-attribute.js';
import { getLineItemDiscount } from '../../../../../utils/get-line-item-discount.js';
import { getLineItemPrice } from '../../../../../utils/get-line-item-price.js';
import { getLocalizedString } from '../../../../../utils/get-localized-string.js';
import { getBundledLineItemProductVariant } from '../bundles/get-bundled-line-item-product-variant.js';

function getBundledProductInfo(bundleLineItem, intl) {
    const { name  } = bundleLineItem.legacyProduct.masterData.current;
    const variant = getBundledLineItemProductVariant(bundleLineItem);
    const variationAttribute = getAttribute(variant, 'variationAttribute');
    const variationAttributeValue = getLocalizedAttrValue(variant, variationAttribute, intl.locale);
    const bundleTitle = getLocalizedString(intl.locale, name);
    return swcHelpers.objectSpread({
        sku: variant.sku,
        title: !!variationAttributeValue ? `${bundleTitle} - ${variationAttributeValue}` : bundleTitle
    }, bundleLineItem.price ? {
        price: getLineItemPrice(bundleLineItem.price).unit,
        discount: getLineItemDiscount(bundleLineItem.discounts, bundleLineItem.price, intl.locale)
    } : {});
}

export { getBundledProductInfo };
//# sourceMappingURL=get-bundled-product-info.js.map
